const f = /(\/{.+?})/g, g = /[/{}]/g;
function a(o, e) {
  const s = { url: o, params: e ?? {} };
  if (!e)
    return s;
  const t = o.match(f);
  return t != null && t.length ? t.reduce(
    (n, l) => {
      const r = l.replace(g, ""), p = e[r];
      return p ? (delete n.params[r], n.url = n.url.replace(
        new RegExp(l, "g"),
        `/${p}`
      )) : n.params[r] = e[r], n;
    },
    {
      url: o,
      params: { ...e }
    }
  ) : s;
}
export {
  a as default
};
